import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
function getStatusColor(status) {
    switch (status) {
        case 'Not Started':
            return 'text-yellow-800 bg-yellow-100';
        case 'Uploading':
            return 'text-blue-800 bg-blue-100';
        case 'Upload Failed':
            return 'text-red-800 bg-red-100';
        case 'Deidentifying':
            return 'text-purple-800 bg-purple-100';
        case 'Upload Successful':
            return 'text-green-800 bg-green-100';
        default:
            return 'text-gray-800 bg-gray-100';
    }
}
function DicomStudyStatusPill(_a) {
    var status = _a.status;
    return (_jsx("span", { className: clsx(status === 'Uploading' && 'motion-safe:animate-pulse', 'inline-flex px-2 text-xs font-semibold leading-5 rounded-full', getStatusColor(status)), children: _jsx("p", { className: "truncate overflow-ellipsis", "data-cy": "dicom-study-status", children: status }) }));
}
export default DicomStudyStatusPill;
